<template>
	<div>
		<b-form-radio-group
			:options="localOptions"
			v-model="proxyValue"
			button-variant="outline-primary"
			:state="state"
			stacked
			buttons
			@change="change"
			:disabled="!active"
		>
		</b-form-radio-group>
		<b-form-input
			v-if="localConfig"
			type="text"
			:value="value"
			:state="state"
			:name="name"
			v-model="proxyValue"
			:readonly="!active"
		></b-form-input>

		<b-form-invalid-feedback :id="`${name}-feedback`">
			{{ errors[name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
const otherOptionsStructure = null;
export default {
	props: {
		options: {
			type: Array,
			required: true
		},
		name: {
			type: String,
			required: true
		},
		value: {
			required: false
		},
		data: {
			type: Object
		},
		state: {
			type: Boolean,
			default: null
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		errors: {
			type: Object
		}
	},
	data() {
		return {
			active: true
		};
	},
	beforeMount() {
		if (typeof this.isActive == "function") this.active = this.isActive(null);
		else this.active = this.isActive;
		otherOptionsStructure = { text: this.$t("commons.other"), value: "" };
	},

	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", this.name);
			}
		},

		localOptions: function () {
			return this.getLocalOptions();
		},
		localConfig: function () {
			return this.getLocalConfig();
		}
	},
	methods: {
		getActive: function () {
			return this.active;
		},
		getLocalOptions() {
			if (
				(this.options.find((suggestion) => suggestion == this.data[this.name]) && this.data[this.name]) ||
				this.data[this.name] == undefined
			)
				this.options.push(otherOptionsStructure.text);

			let response = this.options;
			response = response.map((suggestion) => {
				return { text: suggestion, value: suggestion };
			});

			let other = response.find((suggestion) => suggestion.text == otherOptionsStructure.text);
			if (other) other.value = "";

			return response;
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		},

		getLocalConfig() {
			if (
				(this.options.find((suggestion) => suggestion == this.data[this.name]) && this.data[this.name]) ||
				this.data[this.name] == undefined
			)
				return false;
			return true;
		},
		change(newValue) {
			if (newValue == otherOptionsStructure.value) this.options.pop();
			else if (!this.options.find((option) => option == otherOptionsStructure.text)) {
				//Disparar computed property
				this.options.push(otherOptionsStructure.text);
				this.options.pop();
			}
		}
	}
};
</script>

<style scoped>
.btn {
	margin-top: 5px !important;
}

input {
	margin-top: 10px !important;
}
</style>
